<template>
  <div class="container">
    <div class="section has-text-centered">
      <h1 class="title">Login</h1>
    </div>
    <div class="columns is-vcentered">
      <div class="column is-6 is-offset-3">
        <article
          class="message icon-msg success-msg"
          v-show="!sent && registered"
        >
          <i class="material-icons">assignment_turned_in</i>
          <div class="message-body">
            <h4>You've signed up successfully!</h4>
            <p>Please login with your login details below.</p>
          </div>
        </article>
        <div class="flex-card light-bordered light-raised">
          <div class="card-body">
            <article class="message icon-msg info-msg" v-show="redirect">
              <i class="material-icons">assignment_turned_in</i>
              <div class="message-body">
                <h4>You need to log in to continue</h4>
              </div>
            </article>
            <ValidationObserver ref="observer" v-slot="{ passes }">
              <form v-show="!sent" @submit.prevent="passes(submit)">
                <div class="columns">
                  <div class="column">
                    <div class="control">
                      <ValidationProvider
                        name="Email Address"
                        rules="required|email"
                        v-slot="{ errors }"
                      >
                        <b-field
                          label="Email Address"
                          :type="{ 'is-danger': errors.length > 0 }"
                          :message="errors[0]"
                        >
                          <b-input
                            type="email"
                            name="email"
                            autocomplete="email"
                            v-model="item.email"
                          >
                          </b-input>
                        </b-field>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="column">
                    <div class="control">
                      <ValidationProvider
                        name="Password"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <b-field
                          label="Password"
                          :type="{ 'is-danger': errors.length > 0 }"
                          :message="errors[0]"
                        >
                          <b-input
                            type="password"
                            password-reveal
                            v-model="item.password"
                          >
                          </b-input>
                        </b-field>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div class="has-text-centered">
                  <span class="is-size-6"
                    >Not Registered?
                    <a :href="getRegisterUrl">Create Account</a>
                    | <a href="/forgot-password">Forgot Password?</a></span
                  >
                  <br /><br />
                  <div class="is-block has-text-centered">
                    <button
                      class="button btn-align no-lh raised primary-btn"
                      type="submit"
                      :disabled="loading"
                      :class="{ 'is-loading': loading }"
                    >
                      Login</button
                    ><br />
                    <small class="is-danger" v-if="showError">
                      {{ errorMessage }}
                    </small>
                  </div>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Vue from "vue";
export default {
  data() {
    return {
      showmore: false,
      item: {
        email: "",
        password: "",
      },
      registered: false,
      loading: false,
      sent: false,
      redirect: false,
      showError: false,
      errorMessage: "",
    };
  },
  created() {
    if (this.$route.query.clubid) {
      window.sessionStorage.setItem(
        "ngStorage-clubId",
        '"' + this.$route.query.clubid + '"'
      );
    }

    if (this.$route.query.register) {
      this.registered = true;
    }
  },
  computed: {
    getRegisterUrl() {
      return this.$route.query
        ? `/register?redirect=${this.$route.query.redirect}`
        : `/register`;
    },
  },
  methods: {
    ...mapActions(["login"]),
    submit: function () {
      this.showError = false;
      this.errorMessage = "";
      this.loading = true;
      this.login(this.item)
        .then(() => {
          if (window.fbq) {
            window.fbq("track", "CustomEvent", {
              action: "add_email",
              email: this.item.email,
            });
          }

          if (this.$route.query && this.$route.query.redirect) {
            this.$router.push({ path: this.$route.query.redirect });
          } else {
            this.$router.push({ name: "Home" });
          }

          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          let message = "Error logging in.";
          if (err && err.data) {
            message = err.data.message;
          }
          this.$buefy.toast.open({
            message: message,
            position: "is-top",
            type: "is-danger",
          });
        });
    },
  },
};
</script>